import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // import Link for internal routing
import zappyImg from '../assets/zappy/zappy.png';
import quickbotImg from '../assets/quickbot/quickbot_2.png';

const productsData = [
  {
    name: 'Zappy',
    tagline: 'Powerful WhatsApp marketing automation',
    features: [
      'Send bulk campaigns with 90%+ open rates',
      'Automate follow-ups, reminders, and festive greetings',
      'Segment audience and personalize messaging with ease',
      'Track delivery, click-throughs, and customer responses',
      'Seamless integration with CRM, Google Sheets & more',
    ],
    bgColor: 'bg-blue-100',
    icon: <img src={zappyImg} alt="Zappy" className="w-full h-20 object-contain mb-4" />,
    link: '/zappy',
  },
  {
    name: 'QuickBot',
    tagline: 'Smart chatbot automation for marketing',
    features: [
      'Build no-code WhatsApp bots in under 5 minutes',
      'Guide users through funnels: booking, orders, and queries',
      'Collect leads and sync instantly with your CRM',
      'Use conditions, timers, and logic to personalize conversations',
      'Analytics dashboard for bot performance insights',
    ],
    bgColor: 'bg-blue-100',
    icon: <img src={quickbotImg} alt="QuickBot" className="w-full h-20 object-contain mb-4" />,
    link: '/quickbot',
  },
];

const Products = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-6xl mx-auto px-6 py-16"
    >
      <h1 className="text-4xl font-bold text-center text-blue-700 mb-12">
        Our Products
      </h1>

      <div className="grid md:grid-cols-2 gap-12">
        {productsData.map(({ name, tagline, features, bgColor, icon, link }) => (
          <Link
            key={name}
            to={link}
            className={`${bgColor} rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col items-center text-center`}
          >
            <div className="mb-2">{icon}</div>
            <p className="text-indigo-600 font-medium text-base mb-6">{tagline}</p>

            <div className="w-full bg-white rounded-xl p-5 shadow-inner text-left space-y-3">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <div className="h-2 w-2 mt-2 bg-blue-500 rounded-full mr-3" />
                  <p className="text-gray-700 text-sm leading-relaxed">{feature}</p>
                </div>
              ))}
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-20 text-center">
        <h3 className="text-xl font-semibold text-gray-600 mb-2">New Products Coming Soon</h3>
        <p className="text-gray-500 italic">
          Stay tuned for exciting innovations to help you grow your business even faster!
        </p>
      </div>
    </motion.section>
  );
};

export default Products;
